import { render, staticRenderFns } from "./OrganisationCard.vue?vue&type=template&id=23edfc9c&scoped=true"
import script from "./OrganisationCard.vue?vue&type=script&lang=js"
export * from "./OrganisationCard.vue?vue&type=script&lang=js"
import style0 from "./OrganisationCard.vue?vue&type=style&index=0&id=23edfc9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23edfc9c",
  null
  
)

export default component.exports